/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefit_Redeem_TreeInputs */

const en_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redeem Returning Trees`)
};

const ar_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استبدال الأشجار العائدة`)
};

const de_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederkehrende Bäume einlösen`)
};

const es_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canjear árboles de regreso`)
};

const fr_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échanger les arbres de retour`)
};

const it_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscatta gli alberi di ritorno`)
};

const ja_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復刻樹木の交換`)
};

const ko_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`돌아온 나무 교환`)
};

const pt_br_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resgatar árvores de volta`)
};

const ru_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обменять возвращающиеся деревья`)
};

const th_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แลกรับต้นไม้ที่กลับมา`)
};

const tr_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri dönen ağaçları al`)
};

const zh_cn_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`兑换返场树种`)
};

const zh_tw_benefit_redeem_tree = /** @type {(inputs: Benefit_Redeem_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`兌換回歸樹種`)
};

/**
* | output |
* | --- |
* | "Redeem Returning Trees" |
*
* @param {Benefit_Redeem_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const benefit_redeem_tree = /** @type {((inputs?: Benefit_Redeem_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefit_Redeem_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_benefit_redeem_tree(inputs)
	if (locale === "ar") return ar_benefit_redeem_tree(inputs)
	if (locale === "de") return de_benefit_redeem_tree(inputs)
	if (locale === "es") return es_benefit_redeem_tree(inputs)
	if (locale === "fr") return fr_benefit_redeem_tree(inputs)
	if (locale === "it") return it_benefit_redeem_tree(inputs)
	if (locale === "ja") return ja_benefit_redeem_tree(inputs)
	if (locale === "ko") return ko_benefit_redeem_tree(inputs)
	if (locale === "pt_br") return pt_br_benefit_redeem_tree(inputs)
	if (locale === "ru") return ru_benefit_redeem_tree(inputs)
	if (locale === "th") return th_benefit_redeem_tree(inputs)
	if (locale === "tr") return tr_benefit_redeem_tree(inputs)
	if (locale === "zh_cn") return zh_cn_benefit_redeem_tree(inputs)
	return zh_tw_benefit_redeem_tree(inputs)
});